import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Idioma } from '../../models/idioma';
import { forEach } from '@angular/router/src/utils/collection';

@Pipe({
    name: 'filtroPorHora' // nombre del pipe en las directivas
})

export class FiltrarServiciosPorHora implements PipeTransform{
    // Recibe un arreglo de servicios una hora inicial y una final
    transform(servicios:any, horaInicio:any,horaFin){
        if(servicios != null){ //Valida que no sea nullo el arreglo
            let arregloNuevo=[] //Se declara un arreglo nuevo
                servicios.forEach((servicio)=>{ //Recorrido del arreglo de servicios
                    let hora= new Date(servicio.inicioDeServicio).getHours();
                    //Validacion por hora y por estatus
                    if(hora >= horaInicio && hora <= horaFin && servicio.estatus == 'No Asignado')
                        arregloNuevo.push(servicio)
                })
            return arregloNuevo
        }
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/filtrar-servicios-por-hora.pipe.ts